import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/esm/extends";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import * as S from './styles';
import { mapItemToJSX } from './ItemDescriptor';
import { GetFusionConfig } from './utils';
/* eslint-disable @typescript-eslint/no-explicit-any */

var PrimaryMenu = function PrimaryMenu(props) {
  return React.createElement(S.Menu, _extends({
    openMode: "multiple"
  }, props, {
    type: "normal",
    direction: "ver",
    activeDirection: null,
    mode: "inline",
    triggerType: "click",
    inlineIndent: 16,
    popupAlign: "follow",
    hasArrow: true
  }));
};

var SecondaryMenu = function SecondaryMenu(props) {
  return React.createElement(S.SecondaryMenu, _extends({}, props, {
    type: "line",
    direction: "ver",
    activeDirection: "right",
    triggerType: "click",
    inlineIndent: 8
  }));
};
/**
 * @public
 */


var ConsoleMenu = function ConsoleMenu(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'primary' : _ref$type,
      header = _ref.header,
      items = _ref.items,
      children = _ref.children,
      activeKey = _ref.activeKey,
      defaultActiveKey = _ref.defaultActiveKey,
      _ref$fusionConfig = _ref.fusionConfig,
      fusionConfig = _ref$fusionConfig === void 0 ? {} : _ref$fusionConfig,
      restProps = _objectWithoutProperties(_ref, ["type", "header", "items", "children", "activeKey", "defaultActiveKey", "fusionConfig"]);

  var ExactMenuComponent = type === 'secondary' ? SecondaryMenu : PrimaryMenu;
  var _fusionConfig$prefix = fusionConfig.prefix,
      fusionPrefix = _fusionConfig$prefix === void 0 ? 'next-' : _fusionConfig$prefix;
  return React.createElement(ExactMenuComponent // 透传给Nav
  , _extends({}, restProps, {
    fusionPrefix: fusionPrefix,
    header: header && React.createElement(S.Header, null, header),
    selectedKeys: activeKey,
    defaultSelectedKeys: defaultActiveKey
  }), Array.isArray(items) && items.map(mapItemToJSX), children);
};

var itemBasicShape = {
  key: PropTypes.string,
  label: PropTypes.node,
  render: PropTypes.func,
  visible: PropTypes.bool,
  disabled: PropTypes.bool
};
ConsoleMenu.propTypes = {
  type: PropTypes.oneOf(['primary', 'secondary']),
  header: PropTypes.node,
  items: PropTypes.arrayOf(PropTypes.shape(_objectSpread({}, itemBasicShape, {
    items: PropTypes.arrayOf(PropTypes.shape(itemBasicShape))
  }))),
  activeKey: PropTypes.string,
  defaultActiveKey: PropTypes.string,
  defaultOpenKeys: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string.isRequired)]),
  defaultOpenAll: PropTypes.bool,
  children: PropTypes.node
};
export default GetFusionConfig(ConsoleMenu);